if (document.readyState === 'loading') {
  document.addEventListener('readystatechange', handleLayout);
} else {
  handleLayout();
}

function handleLayout() {
  if (document.readyState === 'loading') return;

  const layout = 'a';

  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('source')) {
    const url = new URL(window.location.href);
    url.searchParams.delete('source');
    window.history.replaceState({}, '', url);
  }

  document.querySelectorAll('[data-layout]').forEach(element => {
    element.style.display = 'none';
  });

  document.querySelectorAll(`[data-layout="${layout}"]`).forEach(element => {
    element.style.display = element.dataset.layoutDisplay || 'block';
  });
}
